import { lazy } from 'react'

export const RenewInstanceLicenseModalAsync = lazy(() => import('./RenewInstanceLicenseModal')
    .then((module) => ({ default: module.RenewInstanceLicenseModal }))
)
